var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _path8, _path9, _path10, _path11, _g4, _ellipse, _ellipse2, _rect, _path12, _path13, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 137,
    viewBox: "0 0 72 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4102 115.409C23.5652 111.904 31.0736 107.826 35.2446 106.272L41.76 117.796L59.1749 121.637C57.0059 121.637 38.5389 130.233 30.5441 134.441V121.505C26.5712 118.649 22.4102 115.409 22.4102 115.409Z",
    fill: "#408CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4308 112.674L59.1707 121.636L41.7559 117.795L51.4308 112.674Z",
    fill: "#0066FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1812 0L92.8488 24.007H51.5137L72.1812 0Z",
    fill: "url(#paint0_linear_1565_29620)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1762 137L51.5086 112.993L92.8437 112.993L72.1762 137Z",
    fill: "url(#paint1_linear_1565_29620)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_29620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6056 6.14429L74 13.3705L81.2805 15.7471L74 18.1237L71.6056 25.3499L69.2112 18.1237L61.9307 15.7471L69.2112 13.3705L71.6056 6.14429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6056 6.37406L73.9314 13.3932L73.9429 13.4279L73.9776 13.4392L81.0476 15.7471L73.9776 18.055L73.9429 18.0663L73.9314 18.1009L71.6056 25.1201L69.2798 18.1009L69.2683 18.0663L69.2336 18.055L62.1636 15.7471L69.2336 13.4392L69.2683 13.4279L69.2798 13.3932L71.6056 6.37406Z",
    stroke: "#3E74FF",
    strokeWidth: 0.144544
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.409 34.2514L43.6896 28.4897L23.022 64.0201L12.409 34.2514Z",
    fill: "url(#paint2_linear_1565_29620)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4094 102.751L23.0224 72.9827L43.69 108.513L12.4094 102.751Z",
    fill: "url(#paint3_linear_1565_29620)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.351 67.8588C125.351 96.6491 101.836 119.993 72.8232 119.993C43.8101 119.993 20.295 96.6491 20.295 67.8588C20.295 39.0686 43.8101 15.7249 72.8232 15.7249C101.836 15.7249 125.351 39.0686 125.351 67.8588Z",
    fill: "url(#paint4_linear_1565_29620)",
    stroke: "url(#paint5_linear_1565_29620)",
    strokeWidth: 0.722719
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_29620)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.8264,
    cy: 67.8596,
    rx: 46.4397,
    ry: 46.0935,
    fill: "url(#paint6_linear_1565_29620)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_29620)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.8257,
    cy: 67.8577,
    rx: 38.6997,
    ry: 38.4112,
    fill: "url(#paint7_linear_1565_29620)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_29620)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0947 61.6384C49.366 59.6808 51.5548 57.9262 53.3069 59.0633L83.6322 78.7436C85.4434 79.9189 84.611 82.7305 82.4519 82.7305H59.4525C58.5468 82.7305 57.7365 82.1675 57.4205 81.3187L50.0947 61.6384Z",
    fill: "url(#paint8_linear_1565_29620)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5402 61.6122C96.2764 59.6593 94.0989 57.8958 92.3417 59.0217L61.5734 78.7368C59.75 79.9051 60.5775 82.7305 62.7431 82.7305H86.0786C86.981 82.7305 87.789 82.1715 88.1073 81.3272L95.5402 61.6122Z",
    fill: "url(#paint9_linear_1565_29620)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8761 54.1317C71.6691 52.5117 73.978 52.5117 74.7709 54.1317L87.3716 79.8752C88.0766 81.3157 87.0279 82.9966 85.4242 82.9966H60.2229C58.6191 82.9966 57.5704 81.3157 58.2755 79.8752L70.8761 54.1317Z",
    fill: "url(#paint10_linear_1565_29620)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_29620",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 52,
    width: 30,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8791 54.1346C71.672 52.5146 73.9809 52.5146 74.7739 54.1346L87.3745 79.8782C88.0796 81.3186 87.0309 82.9995 85.4271 82.9995H60.2258C58.622 82.9995 57.5734 81.3186 58.2784 79.8782L70.8791 54.1346Z",
    fill: "url(#paint11_linear_1565_29620)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_29620)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8373,
    cy: 4.56942,
    rx: 16.8373,
    ry: 4.56942,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 83.25 54.2791)",
    fill: "#7BB0FF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.8265,
    cy: 47.7512,
    rx: 2.95928,
    ry: 2.93722,
    fill: "url(#paint12_linear_1565_29620)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.4427,
    cy: 56.2955,
    rx: 2.42123,
    ry: 2.40318,
    fill: "url(#paint13_linear_1565_29620)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8281,
    y: 85.314,
    width: 29.4329,
    height: 3.98365,
    rx: 1.99183,
    fill: "url(#paint14_linear_1565_29620)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1864 34.5701L53.1441 37.4606L56.0564 38.4112L53.1441 39.3618L52.1864 42.2523L51.2286 39.3618L48.3164 38.4112L51.2286 37.4606L52.1864 34.5701Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5709 21.7661L42.8057 28.5106L49.6009 30.7287L42.8057 32.9469L40.5709 39.6913L38.3362 32.9469L31.541 30.7287L38.3362 28.5106L40.5709 21.7661Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_29620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 101.442L41.7535 117.795C69.4883 103.071 95.9331 113.954 103.673 117.795L113.993 101.442C111.042 98.059 98.6752 91.2171 72.8162 90.9164C46.9572 90.6156 34.4532 97.8083 31.4336 101.442Z",
    fill: "url(#paint15_linear_1565_29620)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_29620",
    x: 58.3171,
    y: 2.53069,
    width: 26.5768,
    height: 26.4328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8068,
    result: "effect1_foregroundBlur_1565_29620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_29620",
    x: 26.3867,
    y: 20.3207,
    width: 92.8789,
    height: 93.6325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.44544
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.172667 0 0 0 0 0.616667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_29620",
    x: 34.126,
    y: 28.0011,
    width: 77.3994,
    height: 79.7134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.44544
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.193203 0 0 0 0 0.4875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_29620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.44544
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4375 0 0 0 0 0.62875 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_29620",
    result: "effect2_innerShadow_1565_29620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_29620",
    x: 44.1306,
    y: 43.3685,
    width: 57.2691,
    height: 50.2654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.44544
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44544
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.111875 0 0 0 0 0.364131 0 0 0 0 0.745833 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_29620",
    x: 16.9792,
    y: 83.68,
    width: 111.468,
    height: 55.7967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.22719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.22719
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_29620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_29620",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_29620",
    x1: 63.5899,
    y1: 9.6028,
    x2: 80.7726,
    y2: 9.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_29620",
    x1: 80.7675,
    y1: 127.397,
    x2: 63.5849,
    y2: 127.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_29620",
    x1: 16.492,
    y1: 46.4377,
    x2: 24.9873,
    y2: 31.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_29620",
    x1: 25.0838,
    y1: 105.335,
    x2: 16.5885,
    y2: 90.5101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#E3EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#B3C2D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_29620",
    x1: 38.9196,
    y1: 28.8239,
    x2: 108.854,
    y2: 107.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0DFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_29620",
    x1: 72.8232,
    y1: 15.3635,
    x2: 72.8232,
    y2: 120.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_29620",
    x1: 43.1566,
    y1: 32.6493,
    x2: 101.97,
    y2: 104.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_29620",
    x1: 47.2156,
    y1: 36.225,
    x2: 78.6917,
    y2: 106.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#376EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1352B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_29620",
    x1: 50.3529,
    y1: 63.2379,
    x2: 65.9784,
    y2: 74.6873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_29620",
    x1: 93.6661,
    y1: 59.931,
    x2: 84.2552,
    y2: 76.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_29620",
    x1: 64.5995,
    y1: 67.0599,
    x2: 81.2825,
    y2: 67.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49728,
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_29620",
    x1: 64.6024,
    y1: 67.0628,
    x2: 81.2855,
    y2: 67.0628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#B1B0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_29620",
    x1: 72.8265,
    y1: 44.814,
    x2: 72.8265,
    y2: 50.6884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_29620",
    x1: 49.4427,
    y1: 53.8923,
    x2: 49.4427,
    y2: 58.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_29620",
    x1: 58.1626,
    y1: 87.3058,
    x2: 87.5955,
    y2: 87.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_29620",
    x1: 35.851,
    y1: 106.452,
    x2: 110.183,
    y2: 105.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#408CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.09fa91b839b9d332551432bc454e1e20.svg";
export { ForwardRef as ReactComponent };